export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_PUBLIC_HOST || ''
export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_PUBLIC_KEY || ''
